import React from "react"

import { Tag } from "antd"
import { PurchaseOrderStatusEnum } from "@finway-group/shared/lib/models"
import { useTranslation } from "react-i18next"

const statusClasses = {
    [PurchaseOrderStatusEnum.DRAFT]: "ant-tag-yellow",
    [PurchaseOrderStatusEnum.WAITING_FOR_APPROVAL]: "ant-tag-gray",
    [PurchaseOrderStatusEnum.PROCUREMENT]: "ant-tag-purple",
    [PurchaseOrderStatusEnum.FULFILLMENT]: "ant-tag-blue",
    [PurchaseOrderStatusEnum.CALCULATE_LINE_ITEMS]: "ant-tag-gray",
    [PurchaseOrderStatusEnum.CONFIRMATION]: "ant-tag-blue",
    [PurchaseOrderStatusEnum.COMPLETED]: "ant-tag-success",
    [PurchaseOrderStatusEnum.FAILED]: "ant-tag-red",
}

interface PurchaseOrderStatusTagProps {
    status: PurchaseOrderStatusEnum
    className?: string
}

export const PurchaseOrderStatusTag = ({ status, className = "" }: PurchaseOrderStatusTagProps) => {
    const { t } = useTranslation()

    return (
        <Tag className={`${statusClasses[status]} ${className}`} data-testid="finway:purchaseStatusTag:status">
            {t(`enum:PurchaseOrderStateEnum.${status}`)}
        </Tag>
    )
}
